export enum AppRoute {
  ROOT = '/',
  ABOUT = '/about/',
  INDEX = '/burial-records/',
  TERMS = '/terms_of_use_and_privacy_policy.html',
}
